import { type FC } from 'react'
import { MeetingMode } from '../../../models/Scheduling'

export const PlaceChip: FC<{ meetingMode?: MeetingMode }> = ({ meetingMode }) =>
  meetingMode === MeetingMode.IN_PERSON ? (
    <span className='paragraph-small zocks-bg-color-primary-light zocks-text-primary-dark rounded-3 px-2 py-1'>In person</span>
  ) : (
    <span className='d-inline-flex align-items-center zocks-gap-0.25 paragraph-small zocks-bg-color-cyan zocks-text-dark-green rounded-3 px-2 py-1'>
      <i className='bi bi-camera-video' />
      Video call
    </span>
  )
